var addfriend  = require('./addfriend.js')
var common  = require('./common.js');
define({
  addfriend,
  common:common
})